module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/logo-steam.848b48a2.svg";